import {
  useAsync,
  useDesign,
  useServices
} from '@app/hooks';
import { ClientId } from '@app/services';
import { Route, navigateToRoute } from '@app/utilities';
import { FC, useEffect } from 'react';

/** Button in the top nav menu. */
const NavButton: FC<{ route: Route; }> = ({ route }) => {
  return (
    <a
      className="nav-button"
      href={`#${route}`}
      id={`${route}-nav`}
      key={route}
      onClick={() => navigateToRoute(route)}
    >{window.l.header[route]}</a>
  );
};

export const AppNav: FC = () => {
  const { avsService } = useServices();
  const serialized = useDesign();
  const [designInfo, designInfoLoading] = useAsync(() => avsService.getDesignInfo(serialized.designId), [serialized.designId]);
  const isCommonModule = serialized.clientId === ClientId.interactionsCommon;
  const hasAgenticApps = !!designInfo?.agenticApplications?.length;

  useEffect(() => {
    if (designInfoLoading) {
      return;
    }
    const route = Route[window.location.hash.slice(1) as keyof(typeof Route)];
    const invalidRoute = (
      !route
      || (!hasAgenticApps && route === Route.agentic)
    );
    navigateToRoute((invalidRoute) ? Route.canvas : route);
  }, [designInfoLoading]);

  return (
    <>
      <NavButton route={Route.canvas} />
      {(!hasAgenticApps) ? null : <NavButton route={Route.agentic} />}
      {(isCommonModule) ? null : <NavButton route={Route.intents} />}
      {(isCommonModule) ? null : <NavButton route={Route.dialogs} />}
      {(isCommonModule) ? null : <NavButton route={Route.testTool} />}
      <NavButton route={Route.settings} />
      <NavButton route={Route.save} />
    </>
  );
};
